module.exports = __webpack_public_path__ + "img/alias.1acaf469.svg";